import React from 'react';
import { Link } from "gatsby";
import { useState } from "react";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const MobileNav = ({nav}) => {

    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        document.body.classList.add('overflow-hidden');
        setIsOpen(true);
    };
    const toggleClose = () => {
        document.body.classList.remove('overflow-hidden');
        setIsOpen(false);
    };

    const goToClose = () => {
        document.body.classList.remove('overflow-hidden');
    };

    

    return (
        <div className="lg:hidden flex items-center">
            <i onClick={toggleOpen} onKeyDown={toggleOpen} role="presentation" className="fa-solid fa-bars text-2xl"></i>
            {isOpen ?
            <div className="bg-white text-grey fixed flex flex-col inset-0 h-screen w-full z-50 overflow-scroll">
                <div onClick={toggleClose} onKeyDown={toggleClose} role="presentation" className="px-6 pt-6 close ml-auto text-2xl"><i className="fa-solid fa-xmark text-green" /></div>
                <div className="p-6">
                <Accordion className="m-nav" transition transitionTimeout={250}>
                {nav.main_nav_items.map((nav, index) => {
                    return(
                        <AccordionItem key={index} header={nav.nav_label}>
                            {nav.drop_down.document.data.sub_nav_item.map((snav, index) => {
                                if(snav.sub_nav !== null){
                                    return(
                                        <div key={index} className="border-b border-grey-light">
                                            <Link onClick={goToClose} to={snav.nav_link.url} className="flex gap-4 pb-3 pt-6">
                                                {/* <span className={"nav-icon flex-none w-10 self-start " + (nav.drop_down.document.data.theme)}>
                                                <img src={snav.icon.url} alt="" />
                                                </span> */}
                                                <span className="w-5/6 flex-none">
                                                    <p className="text-lg mb-1 leading-none">{snav.nav_label}</p>
                                                    <p className="text-sm text-grey-dark m-0">{snav.nav_context.text}</p>
                                                </span>
                                            </Link>
                                            
                                            <div className="flex gap-4 pb-6">
                                            {/* <span className="w-12 p-2 flex-none block"></span> */}
                                            <div className="flex flex-col flex-none gap-2">
                                                    {snav.sub_nav.document.data.sub_nav_item.map((ssnav, index) => {
                                                        return (
                                                                <Link key={index} onClick={goToClose} className="text-teal text-sm" to={ssnav.nav_link.url}>{ssnav.nav_label}</Link>
                                                        )
                                                    })}
                                            </div>
                                            </div>
                                        </div>
                                    )
                                }
                                return(
                                    <div key={index} className="border-b border-grey-light">
                                        <Link onClick={goToClose} to={snav.nav_link.url} className="flex gap-4 py-6 flex-none">
                                            {/* <span className={"nav-icon flex-none w-10 self-start " + (nav.drop_down.document.data.theme)}>
                                                <img src={snav.icon.url} alt="" />
                                            </span> */}
                                            <span className="w-5/6 flex-none">
                                                <p className="text-lg mb-1 leading-none">{snav.nav_label}</p>
                                                <p className="text-sm text-grey-dark m-0">{snav.nav_context.text}</p>
                                            </span>
                                        </Link>
                                    </div>
                                )
                            })}
                            <Link onClick={goToClose} href={nav.resource.document.url} className="flex items-center gap-8 py-6 flex-none border-b border-grey-light">
                                <div className="w-2/4 flex-none">
                                    <div className="text-vs uppercase text-grey-md">
                                    {nav.resource.document.data.resource_label}
                                    </div>
                                    <div className="nav-title leading-normal">
                                        {nav.resource.document.data.resource_title.text}
                                    </div>
                                    </div> 
                                <div className="w-2/4"><GatsbyImage image={getImage(nav.resource.document.data.meta_image)} alt={nav.resource.document.data.meta_image.alt || nav.resource.document.data.resource_title.text} className="rounded-lg shadow-lg" /></div>
                            </Link>
                        </AccordionItem>
                    )
                })}
                </Accordion>
                <div className="flex items-center flex-wrap justify-center pt-6 gap-4">
                    <Link to="/lets-talk/" className="btn text-lg bg-yellow">Let&apos;s talk</Link>
                    <Link to="/contact/" className="btn text-lg bg-grey">Contact</Link>
                </div>
                </div>
                <div className="bg-gradient-to-br from-green to-teal flex flex-wrap justify-center pt-6 pb-44 gap-4">
                <a href="https://lookup.quantum-health.com/" className="btn text-lg bg-black bg-opacity-20 mem-lo"><i className="fa-solid fa-circle-user mr-2" />Members Login</a>
                    <a href="https://www.ccbyqh.com/" className="btn text-lg bg-black bg-opacity-20 items-center pro-lo"><i className="fa-solid fa-briefcase-medical mr-2" />Providers Login</a>
                </div>
            </div> : ''}
        </div>
    );
}

export default MobileNav;
